import { connect } from "react-redux";
import { learningStatsRequest } from "../../../store/slices/selfSlice";
import BannerImage from "../../../assets/images/dashboard_banner.png";
import Clockgif from "../../../assets/images/clock.gif";
import Hourgif from "../../../assets/images/hourglass.gif";
import CompletedGif from "../../../assets/images/completed.gif";
import * as DisplayHelper from "../../../helpers/DisplayHelper";
import "./learning-banner-widget.scss";
import { useMountEffect } from "primereact/hooks";

const LearningBannerWidget = ({
  user,
  learningStatsRequest,
  summary,
  showLearningStats,
}) => {
  useMountEffect(() => {
    if (showLearningStats) learningStatsRequest();
  }, []);

  return (
    <div className="learning-banner-widget ">
      <img src={BannerImage} alt="banner" className="hidden md: block" />
      <div className="content flex-column md:flex-row">
        <div className="banner-title  relative">
          <img
            src={BannerImage}
            alt="banner"
            className="md:hidden absolute top-0 bottom-0 h-full"
          />
          <span className="banner-title-text">
            Welcome <span className="name">{user?.firstName}</span>
          </span>
        </div>
        {(showLearningStats && (
          <div className="banner-stats flex-order-1 md:flex-order-2">
            <div className="stat flex gap-1 align-items-center justify-content-center">
              <span className="icon" style={{ width: "30px", height: "30px" }}>
                <img src={Clockgif} alt="clock" />
              </span>
              <span className="value flex gap-1 flex-column md:flex-row">
                <span className="strong">
                  {DisplayHelper.convertSeconds(
                    summary?.learningStats?.totalTimeSpentInSeconds || 0
                  )}
                </span>
                <span>{"Time Spent"}</span>
              </span>
            </div>
            <div className="stat flex gap-2 align-items-center justify-content-center">
              <span className="icon" style={{ width: "30px", height: "30px" }}>
                <img src={Hourgif} alt="Hourgif" />
              </span>
              <span className="value flex gap-2 flex-column md:flex-row">
                <span className="strong">
                  {summary?.learningStats?.pendingLearningProgramCount || 0}
                </span>
                <span>Pending Programs</span>
              </span>
            </div>
            <div className="stat flex align-items-center justify-content-center">
              <span className="icon" style={{ width: "50px", height: "50px" }}>
                <img src={CompletedGif} alt="completed" />
              </span>
              <span className="value flex gap-2 flex-column md:flex-row">
                <span className="strong">
                  {summary?.learningStats?.completedLearningProgramCount || 0}
                </span>
                <span>Completed Programs</span>
              </span>
            </div>
          </div>
        )) ||
          null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  summary: state.self?.summary || [],
  user: state.self?.user,
});

const mapDispatchToProps = (dispatch) => ({
  learningStatsRequest: () => dispatch(learningStatsRequest()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningBannerWidget);
